<template>
  <v-expansion-panels v-model="open">
    <v-expansion-panel>
      <v-expansion-panel-header style="font-size: 16px; font-weight: bold; color: #506d88">
        <img src="@/assets/PPG_LOGO_PICTO COUL.png" class="exercise-icon" style="width: 30px; vertical-align: -1px; margin-right: 5px" />
        {{ ppgExercise.name }}
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-row>
          <!-- multicam -->
          <v-col cols="12" md="3" lg="4" xl="5">
            <div style="background: #fff" class="p-2">
              <select @change="(e) => changeVideo(e)" class="select mb-5">
                <option :value="ppgExercise.multiCamVideoLink">Multicam</option>
                <option :value="ppgExercise.faceCamVideoLink">Face</option>
                <option :value="ppgExercise.profileCamVideoLink">Profil</option>
                <option :value="ppgExercise.treeQuarterCamVideoLink">Trois quart</option>
              </select>

              <div class="container-video">
                <iframe style="border: none" :src="video || ppgExercise.multiCamVideoLink" class="embed" />
              </div>
            </div>
          </v-col>
          <!-- sets -->
          <v-col cols="12" md="9" lg="8" xl="7" v-if="exerciseSet && exerciseSet.set.length > 0">
            <exercise-sets :exerciseSet="exerciseSet" />
          </v-col>
          <!-- exercise information -->
          <v-col
            :cols="exerciseSet && exerciseSet.set.length > 0 ? 12 : 12"
            :md="exerciseSet && exerciseSet.set.length > 0 ? 12 : 9"
            :lg="exerciseSet && exerciseSet.set.length > 0 ? 12 : 8"
            :xl="exerciseSet && exerciseSet.set.length > 0 ? 12 : 7"
          >
            <v-col>
              <label class="title-label">Caractéristique de l'exercice</label>
              <v-container fluid style="padding-left: 15px; padding-right: 15px">
                <v-row>
                  <!-- critere reussite -->
                  <div class="col-12 col-xl-6" v-if="ppgExercise.critereDeReussite">
                    <label class="font-weight-bold t-blue">Critères de réussite</label>
                    {{ ppgExercise.critereDeReussite }}
                  </div>
                  <!-- Critères de réalisation -->
                  <div class="col-12 col-xl-6" v-if="ppgExercise.criteresDeRealisation">
                    <label class="font-weight-bold t-blue">Critères de réalisation</label>
                    {{ ppgExercise.criteresDeRealisation }}
                  </div>
                  <!-- Complexification -->
                  <div class="col-12 col-xl-6" v-if="ppgExercise.complexification">
                    <label class="font-weight-bold t-blue">Complexification</label>
                    {{ ppgExercise.complexification }}
                  </div>
                  <!-- Simplification -->
                  <div class="col-12 col-xl-6" v-if="ppgExercise.simplification">
                    <label class="font-weight-bold t-blue">Simplification</label>
                    {{ ppgExercise.simplification }}
                  </div>
                  <!-- Variante matériel -->
                  <div class="col-12 col-xl-6" v-if="ppgExercise.varianteMateriel">
                    <label class="font-weight-bold t-blue">Variante matériel</label>
                    {{ ppgExercise.varianteMateriel }}
                  </div>
                  <!-- Informations complémentaires -->
                  <div class="col-12 col-xl-6" v-if="exerciseSet && exerciseSet.critéreRéussite">
                    <label class="font-weight-bold t-blue">Informations complémentaires</label>
                    <p v-html="exerciseSet.critéreRéussite" />
                  </div>
                  <!-- Observables -->
                  <div class="col-12 col-xl-6" v-if="exerciseSet && exerciseSet.exercisesSetObservables.length > 0">
                    <label class="font-weight-bold t-blue">Observables</label>

                    <span>
                      {{ exerciseSet.exercisesSetObservables | joinObservable }}
                    </span>
                  </div>
                </v-row>
              </v-container>
            </v-col>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import ExerciseSets from "@/components/ExerciseSets";

export default {
  name: "ppg-exercise-view",

  components: {
    ExerciseSets,
  },

  props: {
    exerciseSet: Object,
    ppgExercise: Object,
  },

  data() {
    return {
      video: null,
      open: 0,
    };
  },

  filters: {
    joinObservable: function (observables) {
      return observables.map((item) => item.observable.name).join(", ");
    },
  },

  methods: {
    changeVideo: function (e) {
      this.video = e.target.value;
    },
  },
};
</script>
